import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Product} from './product';
import * as fromStore from "../../store";
import {filter, first} from "rxjs/operators";

import {Store} from "@ngrx/store";

@Injectable()
export class ManagerPluginResolver implements Resolve<Product|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getTenWebProductsLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          first()
        )
        .subscribe(() => {
          this._store.select(fromStore.getTenWebManagerPlugin)
            .pipe(first())
            .subscribe((managerPlugin: Product) => {
              resolve(managerPlugin);
            });
        });
    });
  }

}
